import { Col, Divider, Form, Radio, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { filterOption } from '../../../helpers/form';
import { Estados } from '../../../helpers/uf';
import { SwitchLinear } from '../../../styles/Switches';
import Permissoes from '../Permissoes';

export default function PermissoesAcesso({
  selectedPermissions,
  setSelectedPermissions,
  permissaoVisualizarTodosEstados,
  setPermissaoVisualizarTodosEstados,
}) {
  const onChangePermissaoVisualizarEstados = event => {
    const value = event.target.value === 'sim';
    setPermissaoVisualizarTodosEstados(value);
  };

  return (
    <>
      <Divider orientation="left">Permissões e Acessos</Divider>
      <Row gutter={12}>
        <Col xs={24}>
          <Form.Item name="active" label="Usuário" valuePropName="checked">
            <SwitchLinear checkedChildren="Ativo" unCheckedChildren="Inativo" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Form.Item
            initialValue="sim"
            label="Visualizar todos os estados"
            name="visualizarTodosEstados"
          >
            <Radio.Group onChange={onChangePermissaoVisualizarEstados}>
              <Radio.Button value="sim">Sim</Radio.Button>
              <Radio.Button value="nao">Não</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Col>

        {!permissaoVisualizarTodosEstados && (
          <Col xs={24} lg={12}>
            <Form.Item name="estadosVisiveis" label="Permissão para visualizar">
              <Select
                aria-label="estadosVisiveis"
                mode="multiple"
                showSearch
                allowClear
                filterOption={(input, { title }) =>
                  filterOption(input, title, 0)
                }
                options={[
                  ...Estados.map(estado => ({
                    value: estado.nome,
                    title: estado.nome,
                  })),
                ]}
              />
            </Form.Item>
          </Col>
        )}
      </Row>

      <Permissoes
        selectedPermissions={selectedPermissions}
        setSelectedPermissions={setSelectedPermissions}
        withGroup={false}
      />
    </>
  );
}

const PropTypesPermissionsId = PropTypes.shape({
  id: PropTypes.number,
  rule: PropTypes.string,
});

PermissoesAcesso.propTypes = {
  setSelectedPermissions: PropTypes.func.isRequired,
  setPermissaoVisualizarTodosEstados: PropTypes.func.isRequired,
  selectedPermissions: PropTypes.arrayOf(PropTypesPermissionsId).isRequired,
  permissaoVisualizarTodosEstados: PropTypes.bool.isRequired,
};
